import * as o from "react";
import r from "../lib/SSRBase.es.js";
import t from "../defs/LinkedinLogo.es.js";
const e = o.forwardRef((i, n) => /* @__PURE__ */ o.createElement(r, { ref: n, ...i, weights: t }));
e.displayName = "LinkedinLogoIcon";
const s = e;
export {
  s as LinkedinLogo,
  e as LinkedinLogoIcon
};
